'use strict';

window.phit = false; // phit: Page Has Interrupter Tiles

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find(
            '.' + $(this)[0].className.replace(/ /g, '.')
        );
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * handle filters tab after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleFiltersTab($results) {
    var srfwft = $('.selected-refinements-wrapper-filter-tab');
    var selectedFilterCount =
		srfwft && srfwft.find('.selected-refinements')
		    ? srfwft.find('.selected-refinements').length
		    : 0;
    if (selectedFilterCount > 0) {
        $('.js-filters-text')
            .find('.total-filters-count')
            .text('(' + selectedFilterCount + ')')
            .removeClass('d-none');
    } else {
        $('.header-bar-filter-tab').find('.total-filters-count').addClass('d-none');
    }
    updateDom($results, '.refinements-filter-tab');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements,
        /* add filter tab to list of values to be updated */
        '.refinements-filter-tab': handleFiltersTab,
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.selected-refinements-wrapper',
        '.btn.filter-results',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.js-product-search-sort',
        '.result-count',
        '[role="tablist"]',
        /* add filter tab to list of values to be updated */
        '.header-bar-filter-tab',
        '.selected-refinements-wrapper-filter-tab',
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * Function to parse preferences from URL
 * @param {string} url - URL string
 * @return {Object} Preferences object
 */
function parsePreferences(url) {
    var params = new URLSearchParams(url.split('?')[1] || '');
    var preferences = {};
    params.forEach((value, key) => {
        preferences[key] = value.split('|');
    });
    return preferences;
}

/**
 * Function to build URL from preferences
 * @param {string} baseUrl - Base URL
 * @param {Object} preferences - Preferences object
 * @return {string} URL
 */
function buildUrl(baseUrl, preferences) {
    var params = new URLSearchParams();

    Object.keys(preferences).forEach((key, index) => {
        const newIndex = Math.floor(index / 2) + 1;
        if (key.startsWith('prefn')) {
            params.append(`prefn${newIndex}`, preferences[key].join('|'));
        } else if (key.startsWith('prefv')) {
            params.append(`prefv${newIndex}`, preferences[key].join('|'));
        } else {
            params.append(key, preferences[key].join('|'));
        }
    });

    return baseUrl + '?' + params.toString();
}

/**
 * Function to get preferences from selected buttons
 * @param {Object} buttons - Selected buttons
 * @return {Object} Preferences object
 */
function getPreferencesFromButtons(buttons) {
    var preferences = {};
    buttons.each(function () {
        var prefKey = $(this).data('prefkey');
        var prefValue = $(this).data('prefvalue');
        if (!preferences[prefKey]) {
            preferences[prefKey] = new Set();
        }
        preferences[prefKey].add(prefValue);
    });

    var indexedPreferences = {};
    var index = 1;
    Object.keys(preferences).forEach((prefKey) => {
        indexedPreferences[`prefn${index}`] = [prefKey];
        indexedPreferences[`prefv${index}`] = Array.from(preferences[prefKey]);
        index++;
    });

    return indexedPreferences;
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {void}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    var baseUrl = showMoreUrl.split('?')[0];
    var currentPreferences = parsePreferences(showMoreUrl);
    var selectedButtons = $(
        '.refinements-filter-tab .subcategory-menu-item button.selected'
    );
    var newPreferences = getPreferencesFromButtons(selectedButtons);
    // Merge currentPreferences with newPreferences
    Object.keys(currentPreferences).forEach((key) => {
        if (!key.startsWith('prefn') && !key.startsWith('prefv')) {
            newPreferences[key] = currentPreferences[key];
        }
    });
    var newHref = buildUrl(baseUrl, newPreferences);
    showMoreUrl = newHref;
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        },
    });
}

/**
 * Updates the count displayed in the search results.
 *
 * @param {JQuery} $element - The jQuery element containing the new count.
 * @returns {undefined}
 */
function updateCount($element) {
    var countElm = $('.refinement-bar .result-count .search-result-count');
    var countText = countElm.text();
    countElm.text(countText.replace(/[0-9]+/g, $element.data('count')));
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Function to insert an element at a specific position in a jQuery object
 * @param {*} jqObject jquery object of html
 * @param {*} element element to insert
 * @param {*} index position to insert
 * @returns {Object} jQuery object}
 */
function insertAt(jqObject, element, index) {
    var children = jqObject.toArray();
    var ci = 0;
    // loop through each element as element can be something else as well
    children.forEach(function (child, cindex) {
        // console.log('for ci='+cindex+' childHasClass=' + $(child).hasClass('js-from-lm'));
        if ($(child).hasClass('js-from-lm')) {
            if (ci === index) {
                children.splice(cindex, 0, $(element).get(0));
                // console.log('insertAt index: ' + index);
                // console.log('insertAt child index: ' + ci);
            }
            ci++;
        }
    });
    return $(children);
}

/**
 * Duplicate interrupter Tiles for load more response
 *
 * @param {string} response - Ajax response HTML code
 * @param {boolean} searchShowAjax - boolean is true if this function is called from Search-ShowAjax call else false | default false
 * @returns {Object} jQuery object
 */
function dupIntTiles(response, searchShowAjax = false) {
    if (!window.phit) {
        return response;
    }
    var responseHtml = $(response);
    var noOfIntTiles = $('.interupter-tile').length;
    var localStorageIntTiles = localStorage.getItem('interupterTiles');
    if (noOfIntTiles > 0) {
        var preLoadedRegions = $('.product-grid > div');
        // console.log(responseHtml);
        // Extract the position of the interrupter tile
        var positions = [];
        preLoadedRegions.each(function (index) {
            if (
                $(this).hasClass('col-12') &&
				$(this).hasClass('col-md-6') &&
				$(this).find('.interupter-tile').length > 0
            ) {
                // console.log('position of tile', index);
                positions.push({
                    index: positions.length >= 1 ? index - 1 : index,
                    element: $(this).get(0).outerHTML,
                });
            }
        });

        if (!localStorageIntTiles) {
            localStorage.setItem('interupterTiles', JSON.stringify(positions));
        } else if (JSON.parse(localStorageIntTiles).length !== positions.length) {
            positions = JSON.parse(localStorageIntTiles);
        }

        // Loop through each position
        positions.forEach(function (position) {
            // Insert the corresponding .region.col-12.col-sm-6 element at the same position in the AJAX response
            if (searchShowAjax) {
                let prodGridResponseHtml = insertAt(
                    responseHtml.find('.product-grid > div'),
                    position.element,
                    position.index
                );
                responseHtml.find('.product-grid').html(prodGridResponseHtml);
            } else {
                responseHtml = insertAt(responseHtml, position.element, position.index);
            }
            // console.log('count of int tile in response', responseHtml.find('.interupter-tile').length);
        });
        // console.log(responseHtml);
    } else if (localStorageIntTiles) {
        var prevPositions = JSON.parse(localStorageIntTiles);
        // Loop through each position
        prevPositions.forEach(function (position) {
            // Insert the corresponding .region.col-12.col-sm-6 element at the same position in the AJAX response
            if (searchShowAjax) {
                let prodGridResponseHtml = insertAt(
                    responseHtml.find('.product-grid > div'),
                    position.element,
                    position.index
                );
                responseHtml.find('.product-grid').html(prodGridResponseHtml);
            } else {
                responseHtml = insertAt(responseHtml, position.element, position.index);
            }
            // console.log('count of int tile in response', responseHtml.find('.interupter-tile').length);
        });
    }
    return responseHtml;
}

module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.filter-results', function () {
            $('.refinement-bar, .modal-background').show();
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar')
                .closest('.tab-pane.active')
                .siblings()
                .attr('aria-hidden', true);
            $('.refinement-bar')
                .closest('.container.search-results')
                .siblings()
                .attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $('.container').on(
            'click',
            '.refinement-bar button.close, .modal-background',
            function () {
                $('.refinement-bar, .modal-background').hide();
                $('.refinement-bar').siblings().attr('aria-hidden', false);
                $('.refinement-bar')
                    .closest('.row')
                    .siblings()
                    .attr('aria-hidden', false);
                $('.refinement-bar')
                    .closest('.tab-pane.active')
                    .siblings()
                    .attr('aria-hidden', false);
                $('.refinement-bar')
                    .closest('.container.search-results')
                    .siblings()
                    .attr('aria-hidden', false);
                $('.btn.filter-results').focus();
            }
        );
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            // $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar')
                .closest('.row')
                .siblings()
                .attr('aria-hidden', false);
            $('.refinement-bar')
                .closest('.tab-pane.active')
                .siblings()
                .attr('aria-hidden', false);
            $('.refinement-bar')
                .closest('.container.search-results')
                .siblings()
                .attr('aria-hidden', false);
        });
    },

    sort: function () {
        // Handle sort order menu selection
        // added another selector as this was triggering twice as '.container' was found twice.
        $('.container.search-results').on(
            'change',
            '[name=sort-order]',
            function (e) {
                e.preventDefault();

                $.spinner().start();
                $(this).trigger('search:sort', this.selectedOptions);
                var url = this.value;
                if (window.searchCurrentActiveTab) {
                    var query = url.split('?')[1];
                    var activetaburl = $(window.searchCurrentActiveTab).data('sort-url');
                    url = activetaburl + '?' + query;
                }
                $.ajax({
                    url: url,
                    data: { selectedUrl: this.value },
                    method: 'GET',
                    success: function (response) {
                        if (window.searchCurrentActiveTab) {
                            $($(window.searchCurrentActiveTab).attr('href'))
                                .find('.js-result-grid')
                                .empty()
                                .html(response);
                        } else {
                            // eslint-disable-next-line no-param-reassign
                            response = dupIntTiles(response);
                            $('.product-grid').empty().html(response);
                        }
                        // eslint-disable-next-line no-undef
                        yotpoWidgetsContainer.initWidgets();
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    },
                });
            }
        );
    },

    paging: function () {
        // Handle paging selection
        $('.container').on('change', '#grid-paging-header', function (e) {
            e.preventDefault();
            $.spinner().start();
            var url = new URL(window.location);
            url.searchParams.set('sz', $(this).find(':selected').attr('data-value'));

            url.search = url.searchParams;
            // want to reload the window with a new param
            window.location = url.toString();
            // $(this).trigger('search:perpage', this.value);
            // $.ajax({
            //     url: this.value,
            //     data: { selectedUrl: this.value },
            //     method: 'GET',
            //     success: function (response) {
            //         $('.product-grid').empty().html(response);
            //         $.spinner().stop();
            //     },
            //     error: function () {
            //         $.spinner().stop();
            //     },
            // });
        });
        $('.container').on('click', '.grid-paging li a', function (e) {
            e.preventDefault();
            $.spinner().start();
            var url = new URL(window.location);
            url.searchParams.set('start', $(this).attr('data-start'));
            url.searchParams.set('sz', $(this).attr('data-size'));

            url.search = url.searchParams;
            // want to reload the window with a new param
            window.location = url.toString();
        });
    },

    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var $this = $(this);
            var showMoreUrl = $(this).data('url');
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    var resObj = dupIntTiles(response);
                    $this.closest('.grid-footer').replaceWith(resObj);
                    updateSortOptions(response);
                    // eslint-disable-next-line no-undef
                    yotpoWidgetsContainer.initWidgets();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('.container').on(
            'click',
            '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button, .selected-refinements .delete, .js-apply-filters',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();
                $(this).trigger('search:filter', e);

                var searchUrl = $(this).data('href');
                var seoUrl = $(this).data('seo-href') || searchUrl;
                if (seoUrl) {
                    window.history.pushState({}, null, seoUrl);
                }

                var attributeId = '#' + $(this).find('span').last().attr('id');
                $.ajax({
                    url: searchUrl,
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: searchUrl,
                    },
                    method: 'GET',
                    success: function (response) {
                        // eslint-disable-next-line no-param-reassign
                        response = dupIntTiles(response, true);
                        parseResults(response);
                        $('.js-result-grid').empty();
                        if (
                            window.searchCurrentActiveTab &&
							$(window.searchCurrentActiveTab).length > 0
                        ) {
                            $(window.searchCurrentActiveTab).trigger('click');
                        } else {
                            $('#product-search-results-pane').addClass('active');
                        }
                        // eslint-disable-next-line no-undef
                        yotpoWidgetsContainer.initWidgets();
                        $.spinner().stop();
                        $(document).trigger('closeFilterFlyout');
                        $(attributeId).parent('button').focus();
                    },
                    error: function () {
                        $.spinner().stop();
                        $(attributeId).parent('button').focus();
                    },
                });
            }
        );

        if ($('.interupter-tile').length > 0) {
            window.phit = true;
        }

        // PLP filters flyout menu
        $(document).on('click', '.js-filter-opener', function (e) {
            e.preventDefault();
            $('.refinements-flyout-wrapper').addClass('open');
            $('html, body').css('overflow', 'hidden');
            $('.site-main-header').css('z-index', '100');
        });

        $(document).on('click', '.close-filters-js', function (e) {
            e.preventDefault();
            $(document).trigger('closeFilterFlyout');
        });

        $(document).on('closeFilterFlyout', function () {
            $('.refinements-flyout-wrapper').removeClass('open');
            $('html, body').removeAttr('style');
            $('.filters-flyout .subcategory-menu-item').css('display', 'none');
            $('.filters-flyout .dropdown-link').removeClass('active');
            $('.site-main-header').css('z-index', '4000');
            $('.refinement-bar').hide();
        });

        $('.header-bar-filter-tab').on(
            'click',
            '.refinements-filter-tab .subcategory-menu-item button',
            function () {
                // gtm data
                if (!$(this).hasClass('selected')) {
                    $(this).trigger('search:filter:select', {
                        prefType: $(this).attr('data-prefType'),
                        prefVal: $(this).attr('data-prefvalue'),
                    });
                }

                var applyFiltersButton = $('.apply-fIlters-button a.close-filters-js');
                applyFiltersButton.addClass('js-apply-filters');
                $(this).find('.fcheckbox').toggleClass('d-none');
                $(this).toggleClass('selected');

                var currentHref = applyFiltersButton.data('href') || '';
                var currentSeoHref = applyFiltersButton.data('seo-href') || '';

                if (currentHref === '' && currentSeoHref === '') {
                    applyFiltersButton.data('href', $(this).data('href'));
                    applyFiltersButton.data('seo-href', $(this).data('seo-href'));
                    return true;
                }

                var baseUrl = currentHref.split('?')[0];
                var baseSeoUrl = currentSeoHref.split('?')[0];
                var currentPreferences = parsePreferences(
                    currentHref || currentSeoHref
                );

                var selectedButtons = $(
                    '.refinements-filter-tab .subcategory-menu-item button.selected'
                );
                var newPreferences = getPreferencesFromButtons(selectedButtons);

                // Merge currentPreferences with newPreferences
                Object.keys(currentPreferences).forEach((key) => {
                    if (!key.startsWith('prefn') && !key.startsWith('prefv')) {
                        newPreferences[key] = currentPreferences[key];
                    }
                });

                var newHref = buildUrl(baseUrl, newPreferences);
                var newSEOHref = buildUrl(baseSeoUrl, newPreferences);
                applyFiltersButton.data('href', newHref);
                applyFiltersButton.data('seo-href', newSEOHref);
                return true;
            }
        );
    },

    showContentTab: function () {
        window.searchCurrentActiveTab = null;
        // Display content results from the search
        $('.container').on('click', '#articles-tab', function () {
            window.searchCurrentActiveTab = '#articles-tab';
            if ($('#content-search-results').find('div').length === 0) {
                getContent($(this), $('#content-search-results'));
            }
            updateCount($(this));
        });
        $('.container').on('click', '#video-tab', function () {
            window.searchCurrentActiveTab = '#video-tab';
            if ($('#v-search-results').find('div').length === 0) {
                getContent($(this), $('#v-search-results'));
            }
            updateCount($(this));
        });
        $('.container').on('click', '#projects-tab', function () {
            window.searchCurrentActiveTab = '#projects-tab';
            if ($('#p-search-results').find('div').length === 0) {
                getContent($(this), $('#p-search-results'));
            }
            updateCount($(this));
        });
        $('.container').on('click', '#product-search-tab', function () {
            window.searchCurrentActiveTab = null;
            updateCount($(this));
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
            updateCount($(this));
        });
    },

    onPopState: function () {
        $(window).on('popstate', function () {
            window.location = window.location.href;
        });
    },

    categoryDescriptionReadMore: function () {
        $('body').on('click', '.js-read-more-category-description', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $categoryDescription = $this.parent().find('.text');
            if ($categoryDescription.hasClass('show')) {
                $categoryDescription.removeClass('show');
                $this.text('Read More');
            } else {
                $categoryDescription.addClass('show');
                $this.text('Read Less');
            }
        });
    },
};
